import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter, Link } from "react-router-dom"
import { isEmpty } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import * as Yup from "yup"
import { useFormik } from "formik"
import DeleteModal from "../../components/Common/DeleteModal"

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

import {
  getCompanies as onGetCompanies,
  addNewCompany as onAddNewCompany,
  updateCompany as onUpdateCompany,
  deleteCompany as onDeleteCompany,
} from "store/actions"
import CompanyDetailsModal from "./CompanyDetailsModal"


const Companies = props => {
  const dispatch = useDispatch()
  const isFirstTimeLoading = useRef(true)
  const [companyList, setCompanyList] = useState([])
  const [company, setCompany] = useState(null)
  const [modal, setModal] = useState(false)
  const [modalViewDetails, setViewDetailsModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      _id: (company && company._id) || "",
      name: (company && company.name) || "",
      description: (company && company.description) || "",
      integration: (company && company.integration) || "",
      vms: (company && company.vms) || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Your Company Name"),
      description: Yup.string().required(
        "Please Enter Your Company Description"
      ),
      integration: Yup.string(),
      vms: Yup.string(),
    }),
    onSubmit: values => {
      if (isEdit) {
        console.log("EDITING COMPANY: ", values)
        const updateCompany = {
          _id: company._id,
          name: values.name,
          description: values.description,
          businessType: values.integration,
          player: values.vms,
        }
        // update company
        dispatch(onUpdateCompany(updateCompany))
        validation.resetForm()
      } else {
        const newCompany = {
          name: values["name"],
          description: values["description"],
          businessType: values["integration"],
          player: values["vms"],
        }
        console.log("CREATING COMPANY: ", values)
        // save new company
        dispatch(onAddNewCompany(newCompany))
        validation.resetForm()
      }
      toggle()
    },
  })

  const integrationList = [
    { label: 'Pawnmate', value: 'Pawnmate' },
    { label: 'PawnMaster', value: 'PawnMaster' },
    { label: 'Bravo', value: 'Bravo' },
    { label: 'Toast', value: 'Toast' },
    { label: 'Sonnys', value: 'Sonnys' },
  ]

  const vmsList = [
    { label: 'Odyssey', value: 'Odyssey' },
    { label: 'Digital Watch Dog', value: 'Digital Watch Dog' },
  ]

  const { companies } = useSelector(state => ({
    companies: state.companies.companies,
  }))

  const selectRow = {
    mode: "checkbox",
  }

  //pagination customization
  const pageOptions = {
    sizePerPage: 10,
    totalSize: companies.length, // replace later with size(companies),
    custom: true,
  }
  const { SearchBar } = Search

  const CompanyColumns = toggleModal => [
    {
      dataField: "name",
      text: "Name",
      sort: true,
    },
    {
      dataField: "description",
      text: "Description",
      sort: true,
    },
    {
      dataField: "deleted",
      text: "Status",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <Badge
          className={"font-size-12 badge-soft-" + row.badgeclass}
          color={row.deleted ? "danger" : "success"}
          pill
        >
          {row.deleted ? "Deleted" : "Active"}
        </Badge>
      ),
    },
    {
      dataField: "view",
      isDummyField: true,
      text: "View Details",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, company) => (
        <Button
          type="button"
          color="primary"
          className="btn-sm btn-rounded"
          onClick={() => handleCompanyDetails(company)}
        >
          View Details
        </Button>
      ),
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, company) => (
        <>
          <div className="d-flex gap-3">
            <Link
              to="#"
              className="text-success"
              onClick={() => handleCompanyClick(company)}
            >
              <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
              <UncontrolledTooltip placement="top" target="edittooltip">
                Edit
              </UncontrolledTooltip>
            </Link>
            <Link
              to="#"
              className="text-danger"
              onClick={() => onClickDelete(company)}
            >
              <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
              <UncontrolledTooltip placement="top" target="deletetooltip">
                Delete
              </UncontrolledTooltip>
            </Link>
          </div>
        </>
      ),
    },
  ]

  useEffect(() => {
    if (isFirstTimeLoading.current && companies) {
      isFirstTimeLoading.current = false
      dispatch(onGetCompanies())
    }
  }, [dispatch, companies])

  useEffect(() => {
    if (companies) {
      const newCompanies = companies.filter(company => !company.deleted)
      setCompanyList(newCompanies)
    }
  }, [companies])

  const toggle = () => {
    if (modal) {
      setModal(false)
      setCompany(null)
    } else {
      setModal(true)
    }
  }

  const toggleViewModal = () => {
    if (modalViewDetails) {
      setViewDetailsModal(false)
      setCompany(null)
    } else {
      setViewDetailsModal(true)
    }
  }

  const handleCompanyClick = arg => {
    const company = arg

    setCompany({
      _id: company._id,
      name: company.name,
      deleted: company.deleted,
      description: company.description,
      badgeclass: company.badgeclass,
    })

    setIsEdit(true)

    toggle()
  }

  const handleCompanyDetails = arg => {
    const company = arg

    setCompany({
      _id: company._id,
      name: company.name,
      description: company.description,
      deleted: company.deleted,
      badgeclass: company.badgeclass,
    })

    toggleViewModal()
  }

  var node = useRef()
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  //delete company
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = company => {
    setCompany(company)
    setDeleteModal(true)
  }

  const handleDeleteCompany = () => {
    if (company._id) {
      dispatch(onDeleteCompany(company))
      onPaginationPageChange(1)
      setDeleteModal(false)
    }
  }

  const handleCompanyClicks = () => {
    setIsEdit(false)
    toggle()
  }

  const defaultSorted = [
    {
      dataField: "_id",
      company: "desc",
    },
  ]

  return (
    <React.Fragment>
      <CompanyDetailsModal
        isOpen={modalViewDetails}
        toggle={toggleViewModal}
        company={company}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteCompany}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <MetaTags>
          <title>Companies</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Companies" breadcrumbItem="Companies" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="id"
                    columns={CompanyColumns(toggle)}
                    data={companyList}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="id"
                        data={companyList}
                        columns={CompanyColumns(toggle)}
                        bootstrap4
                        search
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row className="mb-2">
                              <Col sm="4">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <SearchBar {...toolkitProps.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                              <Col sm="8">
                                <div className="text-sm-end">
                                  <Button
                                    type="button"
                                    color="success"
                                    className="btn-rounded  mb-2 me-2"
                                    onClick={handleCompanyClicks}
                                  >
                                    <i className="mdi mdi-plus me-1" />
                                    Add Company
                                  </Button>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField="id"
                                    responsive
                                    bcompanyed={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    selectRow={selectRow}
                                    classes={
                                      "table align-middle table-nowrap table-check"
                                    }
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    ref={node}
                                  />
                                </div>
                                <Modal isOpen={modal} toggle={toggle}>
                                  <ModalHeader toggle={toggle} tag="h4">
                                    {!!isEdit ? "Edit Company" : "Add Company"}
                                  </ModalHeader>
                                  <ModalBody>
                                    <Form
                                      onSubmit={e => {
                                        e.preventDefault()
                                        validation.handleSubmit()
                                        return false
                                      }}
                                    >
                                      <Row form>
                                        <Col className="col-12">
                                          <div className="mb-3">
                                            <Label className="form-label">
                                              Company Name
                                            </Label>
                                            <Input
                                              name="name"
                                              type="text"
                                              validate={{
                                                required: { value: true },
                                              }}
                                              onChange={validation.handleChange}
                                              onBlur={validation.handleBlur}
                                              value={
                                                validation.values.name || ""
                                              }
                                              invalid={
                                                validation.touched.name &&
                                                validation.errors.name
                                                  ? true
                                                  : false
                                              }
                                            />
                                            {validation.touched.name &&
                                            validation.errors.name ? (
                                              <FormFeedback type="invalid">
                                                {validation.errors.name}
                                              </FormFeedback>
                                            ) : null}
                                          </div>
                                          <div className="mb-3">
                                            <Label className="form-label">
                                              Company Description
                                            </Label>
                                            <Input
                                              name="description"
                                              type="textarea"
                                              id="textarea"
                                              maxLength="225"
                                              rows="3"
                                              validate={{
                                                required: { value: true },
                                              }}
                                              onChange={validation.handleChange}
                                              onBlur={validation.handleBlur}
                                              value={
                                                validation.values.description ||
                                                ""
                                              }
                                              invalid={
                                                validation.touched
                                                  .description &&
                                                validation.errors.description
                                                  ? true
                                                  : false
                                              }
                                            />
                                            {validation.touched.description &&
                                            validation.errors.description ? (
                                              <FormFeedback type="invalid">
                                                {validation.errors.description}
                                              </FormFeedback>
                                            ) : null}
                                          </div>
                                          <div className="mb-3">
                                              <Label className="form-label">
                                                Main Integration
                                              </Label>
                                              <Input
                                                name="integration"
                                                type="select"
                                                className="form-select"
                                                onChange={
                                                  validation.handleChange
                                                }
                                                onBlur={validation.handleBlur}
                                                value={
                                                  validation.values.integration ||
                                                  ""
                                                }
                                              >
                                                <option value="" key="none">
                                                  Select a Main Integration
                                                </option>
                                                {integrationList.map(
                                                  (item, index) => (
                                                    <option
                                                      value={item.value}
                                                      key={item.value}
                                                    >
                                                      {item.label}
                                                    </option>
                                                  )
                                                )}
                                              </Input>
                                            </div>
                                          <div className="mb-3">
                                              <Label className="form-label">
                                                Main VMS
                                              </Label>
                                              <Input
                                                name="vms"
                                                type="select"
                                                className="form-select"
                                                onChange={
                                                  validation.handleChange
                                                }
                                                onBlur={validation.handleBlur}
                                                value={
                                                  validation.values.vms ||
                                                  ""
                                                }
                                              >
                                                <option value="" key="none">
                                                  Select a Main VMS
                                                </option>
                                                {vmsList.map(
                                                  (item, index) => (
                                                    <option
                                                      value={item.value}
                                                      key={item.value}
                                                    >
                                                      {item.label}
                                                    </option>
                                                  )
                                                )}
                                              </Input>
                                            </div>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col>
                                          <div className="text-end">
                                            <button
                                              type="submit"
                                              className="btn btn-success save-user"
                                            >
                                              Save
                                            </button>
                                          </div>
                                        </Col>
                                      </Row>
                                    </Form>
                                  </ModalBody>
                                </Modal>
                              </Col>
                            </Row>
                            <Row className="align-items-md-center mt-30">
                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Companies.propTypes = {
  companies: PropTypes.array,
  onGetCompanies: PropTypes.func,
  onAddNewCompany: PropTypes.func,
  onDeleteCompany: PropTypes.func,
  onUpdateCompany: PropTypes.func,
}

export default withRouter(Companies)
